import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import TicketVerification from './pages/ticket-verification';
import PaymentConfirmation from './pages/payment-confirmation';
import PurchaseFlow from './pages/purchase-flow';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/ticket-verification" element={<TicketVerification />} />
        <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
        <Route path="/purchase-flow" element={<PurchaseFlow />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;